// src/mocks/insurance.mock-data.ts

import type {
  Claim,
  EligibilityVerification,
  Policy,
  Provider,
  Report,
} from "../contexts/InsuranceContextType";

const now = () => new Date().toISOString();

const daysAgo = (days: number) =>
  new Date(
    Date.now() - days * 24 * 60 * 60 * 1000
  ).toISOString();

const dateOnly = (value: string) =>
  value.split("T")[0];

export const SAMPLE_CLAIMS: Claim[] = [];

export const SAMPLE_POLICIES: Policy[] = [];

export const SAMPLE_PROVIDERS: Provider[] = [];

export const SAMPLE_ELIGIBILITY_VERIFICATIONS:
  EligibilityVerification[] = [];

export const SAMPLE_REPORTS: Report[] = [];